import {CreateEntity} from './entity.model';
import {PromptVersion, PromptVersionModel} from './prompt-version.model';
import {NamedEntity, NamedEntityModel} from './named-entity.model';

export type Visibility = 'public' | 'private';

export interface Prompt extends NamedEntity {
  description?: string;
  visibility: Visibility;
  version: number;
  created_at?: string;
  updated_at?: string;
  latest_version?: PromptVersion;
}

export class PromptModel extends NamedEntityModel<Prompt> {
  description?: string;
  visibility: Visibility;
  version: number;
  createdAt?: Date;
  updatedAt?: Date;
  latestVersion?: PromptVersionModel;

  constructor(source: Prompt) {
    super(source, 'prompt');
    this.description = source.description;
    this.visibility = source.visibility;
    this.version = source.version;
    this.createdAt = source.created_at ? new Date(source.created_at) : undefined;
    this.updatedAt = source.updated_at ? new Date(source.updated_at) : undefined;

    if (source.latest_version) {
      this.latestVersion = new PromptVersionModel(source.latest_version);
    }
  }
}

export interface CreatePrompt extends CreateEntity<Prompt> {
  initial_content: string;
}
